export type ProductType = Array<{
  label: string
  value: MortgageReason
  isDisabled?: boolean
}>

export const ProductTypes: ProductType = [
  {
    label: 'productTypes.firstTimeBuy',
    value: 'REASON_FTB',
  },
  {
    label: 'productTypes.houseMove',
    value: 'REASON_HOUSE_MOVE',
  },
  {
    label: 'productTypes.remortgage',
    value: 'REASON_REMORTGAGE',
  },
  {
    label: 'productTypes.buyToLetRemortgage',
    value: 'REASON_BTL_REMORTGAGE',
  },
  {
    label: 'productTypes.buyToLet',
    value: 'REASON_BTL',
  },
  {
    label: 'productTypes.protection',
    value: 'REASON_PROTECTION',
  },
  {
    label: 'productTypes.businessProtection',
    value: 'REASON_BUSINESS_PROTECTION',
  },
  {
    label: 'productTypes.equityRelease',
    value: 'REASON_EQUITY_RELEASE',
  },
  {
    label: 'productTypes.bridging',
    value: 'REASON_BRIDGING',
  },
  {
    label: 'productTypes.commercial',
    value: 'REASON_COMMERCIAL',
  },
  {
    label: 'productTypes.homeInsurance',
    value: 'REASON_GENERAL_INSURANCE',
  },
]
